module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("Praise for "), _c('i', [_vm._v("Holy Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("“A haunting and lyrical triumph.” —"), _c('i', [_vm._v("Time")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("“Sterling is the best at seriously trying to predict future trends. In "), _c('i', [_vm._v("Holy Fire")]), _vm._v(" he has combined predictive talent with a sympathetic and complex heroine who can blend the old and the new.” —"), _c('i', [_vm._v("The Denver Post")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("“A patented Sterling extra-special.” —"), _c('i', [_vm._v("Newsday")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("“The social dimension is his bailiwick, and while Sterling has always had a sense of humor, particularly in his stories, he’s never written anything with the satirical zing and laff relief of the first 70 or so pages.” —"), _c('i', [_vm._v("The Village Voice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("“Science fiction that makes the rest of near-future SF look toylike in comparison. It’s as if Sterling is the only writer paying attention to what’s happening in the real world.” —"), _c('i', [_vm._v("Locus")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee5517ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Praise.vue
// module id = 66
// module chunks = 0